import { render, staticRenderFns } from "./descriptionOfProject.vue?vue&type=template&id=f3caa634&scoped=true&"
import script from "./descriptionOfProject.vue?vue&type=script&lang=js&"
export * from "./descriptionOfProject.vue?vue&type=script&lang=js&"
import style0 from "./descriptionOfProject.vue?vue&type=style&index=0&id=f3caa634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3caa634",
  null
  
)

export default component.exports